import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getClienteEstoqueModulo from "../queries/getClientesEstoque";

export function useGetClienteEstoque(ClienteId: number) {
  const resultQuery = useQuery(
    [`${URLS.ESTOQUE_API}`, {
      params: {ClienteId}
    }], 
    () => getClienteEstoqueModulo(ClienteId));

  return resultQuery;
}
